import { render, staticRenderFns } from "./TextfieldForm.vue?vue&type=template&id=47abf115&scoped=true"
import script from "./TextfieldForm.vue?vue&type=script&lang=js"
export * from "./TextfieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abf115",
  null
  
)

export default component.exports